var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_file-alt",
    "data-name": "solid file-alt",
    d: "M8.75,5.312V0H.937A.935.935,0,0,0,0,.937V19.063A.935.935,0,0,0,.937,20H14.063A.935.935,0,0,0,15,19.063V6.25H9.688A.94.94,0,0,1,8.75,5.312Zm2.5,9.219a.47.47,0,0,1-.469.469H4.219a.47.47,0,0,1-.469-.469v-.313a.47.47,0,0,1,.469-.469h6.563a.47.47,0,0,1,.469.469Zm0-2.5a.47.47,0,0,1-.469.469H4.219a.47.47,0,0,1-.469-.469v-.312a.47.47,0,0,1,.469-.469h6.563a.47.47,0,0,1,.469.469Zm0-2.812v.313a.47.47,0,0,1-.469.469H4.219a.47.47,0,0,1-.469-.469V9.219a.47.47,0,0,1,.469-.469h6.563A.47.47,0,0,1,11.25,9.219ZM15,4.762V5H10V0h.238A.937.937,0,0,1,10.9.273L14.727,4.1A.935.935,0,0,1,15,4.762Z",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.82ba64234051dfbe8739a919bdbdd5e0.svg";
export { ForwardRef as ReactComponent };